import { RawShaderMaterial } from 'three';

import { globalUniforms, viewportUniforms } from '../../utils/uniforms.js';

import fs from './fragment.fs?hotShader';
import vs from './vertex.vs?hotShader';

class BackgroundMaterial extends RawShaderMaterial {
	constructor() {
		super({
			uniforms: {
				uResolution: viewportUniforms.uResolution,
				uDarkMode: globalUniforms.uDarkMode,
			},
		});

		vs.use(this);
		fs.use(this);
	}
}

export default BackgroundMaterial;
